import React, { FC } from "react";

import styled from "styled-components";

type Theme = "dark" | "light";

interface PageProps {
  className?: string;
  children: React.ReactNode;
  avatar?: string;
  theme: Theme;
}

export const Page: FC<PageProps> = ({ className, children, avatar, theme }) => {
  return (
    <StyledLayout className={className || ""}>
      <AvatarBg className="avatar-bg" avatarUrl={avatar} data-theme={theme} />
      {children}
    </StyledLayout>
  );
};

const StyledLayout = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  min-width: 100vw;
  min-height: 100dvh;
  position: relative;
  isolation: isolate;
  overflow: auto;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    /* min-height: auto; */
    overflow: unset;
  }
`;

const AvatarBg = styled.div<{ avatarUrl?: string }>`
  background-image: ${({ avatarUrl }) =>
    avatarUrl
      ? `url(${avatarUrl})`
      : "url(https://media.development.trac.co/avatar/5d72ccb3-8b44-418b-a9a2-f3d6d018ca5b/image-jpeg/5d72ccb3-8b44-418b-a9a2-f3d6d018ca5b-large.jpg)"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  z-index: -1;
  opacity: 0.2;
  filter: blur(250px);
  pointer-events: none;
  user-select: none;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.colors.background};
    min-width: 100vw;
    min-height: 100dvh;
    z-index: -1;
    opacity: 0.1;
    pointer-events: none;
    user-select: none;
  }
  &[data-theme="dark"] {
    opacity: 0.2;
  }
`;
